import type { FormikValues } from 'formik';
import * as Yup from 'yup';

import FormikForm from '../../../../components/Formik/Form/FormikForm.js';
import { regexValidator } from '../../../../helpers/regexValidator.js';


interface EvaluationFormValues {
  osProjectName: string;
}

interface EvaluationFormProps {
  disabled: boolean;
  onSubmit: (values: EvaluationFormValues) => Promise<void>;
}

const EvaluationForm = ({ disabled, onSubmit }: EvaluationFormProps): React.JSX.Element => {
  const fields = [
    {
      fieldType: 'text',
      name: 'osProjectName',
      label: 'Project Name',
      disabled,
    },
  ];

  const initialValues = {
    osProjectName: '',
  };

  const validationSchema = Yup.object().shape({
    osProjectName: Yup.string()
      .required('Required')
      .matches(regexValidator.noSpace, 'Spaces not allowed'),
  });

  return (
    <FormikForm
      fields={fields}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values: FormikValues) => {
        onSubmit(values as EvaluationFormValues).catch((error: unknown) => {
          console.error('Error submitting form:', error);
        });
      }}
      submitLabel='Submit'
    />
  );
};

export default EvaluationForm;
